import * as React from "react"
import { connect } from "react-redux"
import Upload from "rc-upload"

import { Symbols } from "@tenforce/toolbox-fontmap"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"

import env from "../../../../env"

import { mapDispatchToProps, DispatchProps } from "../../actions"
import { Labels } from "../../../../util/Translations"

const applicationPath = env.applicationPath

type Props = DispatchProps

export const UploadConfiguration = ({
    requestConfigurations,
}: Props): JSX.Element => {
    const { ExportUploadConfiguration } = Labels

    return (
        <Upload
            action={`${applicationPath}/connectapi/deployment/uploadconfiguration`}
            onSuccess={(): void => {
                requestConfigurations()
            }}
        >
            <Action
                actionType={ActionType.icon}
                data-ft-deployment="upload-configuration"
                title={ExportUploadConfiguration}
            >
                {Symbols.Create}
            </Action>
        </Upload>
    )
}

export default connect(null, mapDispatchToProps)(UploadConfiguration)
